import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { TeacherAPI } from "../../../../api";
import { TeacherItem } from "../TeacherItem";
import { useTranslation } from "react-i18next";
import "./TeacherList.scss";

const teacherController = new TeacherAPI();

export function TeacherList(props) {
  const { user, accessToken, reload, onReload } = props;
  const { t } = useTranslation("teachers");
  const [teachers, setTeachers] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const response = await teacherController.getTeachersByInstitution(
          accessToken,
          user.user.institutions[0],
          { page },
        );
        setTeachers(response.teachers);
        setPagination({
          total: response.totalDocs,
          page: response.page,
          limit: response.limit,
          pages: response.totalPages,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, user.user.institutions, onReload, reload, accessToken]);

  const changePage = (e, data) => {
    setPage(data.activePage);
  };

  if (!teachers) return <Loader active inline="centered" />;
  if (size(teachers) === 0) return <h2>{t("list.noTeachers")}</h2>;

  return (
    <div className="teacher-list-container">
      <div className="list-teacher">
        {map(teachers, (teacher) => (
          <TeacherItem
            key={teacher._id}
            accessToken={accessToken}
            teacher={teacher}
            onReload={onReload}
          />
        ))}
      </div>

      <div className="list-teacher__pagination">
        <Pagination
          defaultActivePage={pagination.page}
          totalPages={pagination.pages}
          ellipsisItem={null}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
